import styled from 'styled-components'
import PropTypes from 'prop-types'
import { useLessons } from 'querys/lesson'
import { Typography } from 'common/typography'
import Lessons from 'courses/details/lessons'
import { useCourse } from 'querys/course'
import useIntersectionObserver from 'hooks/use-intersection-observer'

const LessonsStyled = styled.section`
  scroll-margin-top: 150px;
  grid-area: lessons;
  padding: 50px 0;
  @media(min-width: 1024px) {
    padding: 50px 0 0;
  }
`

function CourseLessons({ setActive }) {
  const { data: chapters } = useLessons()
  const { data } = useCourse()
  const { slug, is_free } = data

  const { ref: lessonsRef } = useIntersectionObserver({
    onIntersect: () => setActive('temario'),
    rootMargin: '0px 0px -100px 0px',
  })

  if (!data || !chapters) return null

  return (
    <LessonsStyled aria-labelledby="lessons" id="temario" ref={lessonsRef}>
      <Typography small="headline6" large="headline5" id="lessons" as="h2" color="var(--baseNeutral)">
        Estas son todas las clases
      </Typography>
      <Lessons
        chapters={chapters}
        course={slug}
        free={is_free}
      />
    </LessonsStyled>
  )
}

CourseLessons.propTypes = {
  setActive: PropTypes.func.isRequired,
}

export default CourseLessons
